import React from 'react';
import PropTypes from 'prop-types';
import AddressResult from '@/components/organisms/AddressResult';

const ServiceResults = ({ pos, markers, googleMap, hidden }) => {
  if (hidden) return null;
  return (
    <div className='dln-serviceLocator__results'>
      {pos.map((entry, i) => (
        <AddressResult
          key={entry.name}
          index={i}
          store={entry}
          markers={markers}
          googleMap={googleMap}
        />
      ))}
    </div>
  );
};

ServiceResults.propTypes = {
  pos: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  markers: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  googleMap: PropTypes.shape(),
  hidden: PropTypes.bool,
};

ServiceResults.defaultProps = {
  googleMap: null,
  hidden: false,
};

export default ServiceResults;
